<!-- 
    添加标签
    jay 2020-02-28
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      :title="$t('recharge.addLabel')"
      :fixed="true"
      left-arrow
      @click-left="navbarback"
    />
    <div class="scroll-wrapper">
      <scroll>
        <div class="add-tag tag-item">
          <h2 class="tag-title">
            <span>{{ $t("recharge.addNewLabel") }}</span>
            <a @click="userMobileTagsAdd">{{ $t("common.save") }}</a>
          </h2>
          <van-cell-group :border="false" class="tag-input">
            <van-field
              :border="false"
              @focus="inputFocus"
              v-model="tagName"
              :placeholder="$t('recharge.enterLabelName')"
            />
          </van-cell-group>
        </div>
        <div class="my-tag tag-item">
          <h2 class="tag-title">
            <span>{{ $t("recharge.myLabel") }}</span>
            <a @click="tagManageFlag = true">
              {{ $t("recharge.labelManagement") }}
            </a>
          </h2>
          <div class="tag-list">
            <a
              :class="{ active: tagActive == index }"
              v-for="(item, index) in tagList"
              :key="index"
              @click="chooseTag(index)"
              >{{ item.tag_name }}</a
            >
            <a class="placeholder-item"></a>
            <a class="placeholder-item"></a>
            <a class="placeholder-item"></a>
            <a class="placeholder-item"></a>
          </div>
        </div>
        <div class="button-wrap">
          <van-button block type="primary" @click="userMobilesAdd">
            {{ $t("recharge.saveNumberToLabel") }}
          </van-button>
          <p class="tips">
            {{ $t("recharge.clickNumberToLabel") }}
          </p>
        </div>
      </scroll>
    </div>
    <transition name="slide">
      <tag-manage
        v-if="tagManageFlag"
        :tagManageFlag.sync="tagManageFlag"
        :tagList="tagList"
        @changeTagList="changeTagList"
      />
    </transition>
  </div>
</template>

<script>
import TagManage from "@/components/recharge/tagManage";
export default {
  props: {
    tagAddFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    },
    tagAddMobile: {
      //添加标签号码数组
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {
    TagManage
  },
  data() {
    return {
      tagActive: 0, //标签选中
      tagName: "", //标签名
      tagNew: false, //判断当前标签是否需要选中最后一个,用于新增标签
      tagManageFlag: false //标签管理
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navbarback() {
      //返回上一页
      this.$emit("update:tagAddFlag", false);
    },
    changeTagList(data) {
      //修改标签,包括编辑和删除
      let vm = this;
      let arr = JSON.parse(JSON.stringify(vm.tagList));
      if (data.type == 1) {
        //编辑标签
        arr[data.index].tag_name = data.tagName;
      } else {
        //删除标签
        arr.splice(data.index, 1);
        //标签删除时，判断当前标签是否有选中
        if (vm.tagActive == data.index) {
          //如果选中的和删除的相同
          if (data.index == vm.tagList.length - 1) {
            //如果删除的是最后一个,则删除完成之后，最后一个
            vm.tagNew = true;
          } else if (data.index == 0) {
            //如果删除的是第一个,则删除完成之后，还是显示第一个
            vm.tagActive = 0;
          } else {
            vm.tagActive = vm.tagActive - 1;
          }
        }
        if (vm.tagActive > data.index) {
          vm.tagActive = vm.tagActive - 1;
        }
      }
      vm.$emit("update:tagList", arr);
    },
    inputFocus() {
      //输入框获取到焦点后，取消标签选中
      let vm = this;
      vm.tagActive = -1;
    },
    chooseTag(index) {
      //选择标签
      let vm = this;
      vm.tagActive = index;
      //选择标签时，清空输入框
      vm.tagName = "";
    },
    userMobilesAdd() {
      // 添加电话簿手机号
      let vm = this;
      if (vm.tagActive == -1) {
        vm.$toast(vm.$t("recharge.selectLabel"));
        return;
      }
      //判断当前输入框是否有号码
      console.log(vm.tagAddMobile);
      if (!vm.tagAddMobile.length) {
        vm.$toast(vm.$t("common.enterMobile"));
        return;
      }
      let params = {};
      params.tag = vm.tagList[vm.tagActive].id;
      params.mobile = vm.tagAddMobile.join(",");
      vm.$post("/app/user/userMobilesAdd", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("userMobilesAdd", res);
        vm.$toast(res.msg);
        //添加成功后，返回上一页
        vm.navbarback();
      });
    },
    userMobileTagsAdd() {
      // 添加电话簿标签
      let vm = this;
      let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
      if (!reg.test(vm.tagName)) {
        vm.$toast(vm.$t("recharge.enter2-4letterOrChinese"));
        return false;
      }
      let params = {};
      params.tag_name = vm.tagName;
      vm.$post("/app/user/userMobileTagsAdd", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("userMobileTagsAdd", res);
        if (res.code == 0) {
          //添加成功后重新获取标签列表
          vm.$emit("getUserMobileTags");
          //清空输入框
          vm.tagName = "";
          //标签选中最后一个
          vm.tagNew = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {
    tagList() {
      let vm = this;
      if (vm.tagNew && vm.tagList.length) {
        vm.tagActive = vm.tagList.length - 1;
        //标签选中最后一个
        vm.tagNew = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tag-item {
  padding: 0 15px;
  margin-top: 20px;
  .tag-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 400;
    a {
      color: #2042ab;
      font-size: 14px;
    }
  }
  .tag-list {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    a {
      min-width: 78px;
      height: 28px;
      border-radius: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eff2f5;
      color: #4a4a4a;
      font-size: 14px;
      &.active {
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
        color: #fff;
      }
      &.placeholder-item {
        height: 1.1px;
        border-radius: 0;
        background: none;
      }
    }
  }
  .tag-input {
    height: 34px;
    padding: 0;
    margin-top: 6px;
    border-bottom: 1.1px solid #cacaca;
    display: flex;
    align-items: center;
    /deep/.van-cell {
      padding: 0;
      font-size: 14px;
    }
  }
}
</style>
